import { render, staticRenderFns } from "./InstantDeliveryCard.vue?vue&type=template&id=62badbfd&scoped=true&"
import script from "./InstantDeliveryCard.vue?vue&type=script&lang=js&"
export * from "./InstantDeliveryCard.vue?vue&type=script&lang=js&"
import style0 from "./InstantDeliveryCard.vue?vue&type=style&index=0&id=62badbfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62badbfd",
  null
  
)

export default component.exports